/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FieldValidationDto } from './field-validation-dto';
/**
 * 
 * @export
 * @interface ServiceFormFieldDto
 */
export interface ServiceFormFieldDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormFieldDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormFieldDto
     */
    type: ServiceFormFieldDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormFieldDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormFieldDto
     */
    placeholder?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceFormFieldDto
     */
    required: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceFormFieldDto
     */
    options?: Array<string>;
    /**
     * 
     * @type {FieldValidationDto}
     * @memberof ServiceFormFieldDto
     */
    validation?: FieldValidationDto;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceFormFieldDtoTypeEnum {
    Text = 'text',
    Email = 'email',
    Phone = 'phone',
    Select = 'select',
    Radio = 'radio',
    Checkbox = 'checkbox',
    Textarea = 'textarea',
    Date = 'date',
    Time = 'time'
}

